const TimeZones = [
  "Pacific/Pago_Pago",
  "Pacific/Honolulu",
  "America/Los_Angeles",
  "America/Tijuana",
  "America/Denver",
  "America/Phoenix",
  "America/Mazatlan",
  "America/Chicago",
  "America/Mexico_City",
  "America/Regina",
  "America/Guatemala",
  "America/Bogota",
  "America/New_York",
  "America/Lima",
  "America/Caracas",
  "America/Halifax",
  "America/Guyana",
  "America/La_Paz",
  "America/Argentina/Buenos_Aires",
  "America/Godthab",
  "America/Montevideo",
  "America/St_Johns",
  "America/Santiago",
  "America/Sao_Paulo",
  "Atlantic/South_Georgia",
  "Atlantic/Azores",
  "Atlantic/Cape_Verde",
  "Africa/Casablanca",
  "Europe/Dublin",
  "Europe/Lisbon",
  "Europe/London",
  "Africa/Monrovia",
  "Africa/Algiers",
  "Europe/Amsterdam",
  "Europe/Berlin",
  "Europe/Brussels",
  "Europe/Budapest",
  "Europe/Belgrade",
  "Europe/Prague",
  "Europe/Copenhagen",
  "Europe/Madrid",
  "Europe/Paris",
  "Europe/Rome",
  "Europe/Stockholm",
  "Europe/Vienna",
  "Europe/Warsaw",
  "Europe/Athens",
  "Europe/Bucharest",
  "Africa/Cairo",
  "Asia/Jerusalem",
  "Africa/Johannesburg",
  "Europe/Helsinki",
  "Europe/Kiev",
  "Europe/Kaliningrad",
  "Europe/Riga",
  "Europe/Sofia",
  "Europe/Tallinn",
  "Europe/Vilnius",
  "Europe/Istanbul",
  "Asia/Baghdad",
  "Africa/Nairobi",
  "Europe/Minsk",
  "Asia/Riyadh",
  "Europe/Moscow",
  "Asia/Tehran",
  "Asia/Baku",
  "Europe/Samara",
  "Asia/Tbilisi",
  "Asia/Yerevan",
  "Asia/Kabul",
  "Asia/Karachi",
  "Asia/Yekaterinburg",
  "Asia/Tashkent",
  "Asia/Colombo",
  "Asia/Almaty",
  "Asia/Dhaka",
  "Asia/Rangoon",
  "Asia/Bangkok",
  "Asia/Jakarta",
  "Asia/Krasnoyarsk",
  "Asia/Shanghai",
  "Asia/Hong_Kong",
  "Asia/Kuala_Lumpur",
  "Asia/Irkutsk",
  "Asia/Singapore",
  "Asia/Taipei",
  "Asia/Ulaanbaatar",
  "Australia/Perth",
  "Asia/Yakutsk",
  "Asia/Seoul",
  "Asia/Tokyo",
  "Australia/Darwin",
  "Australia/Brisbane",
  "Pacific/Guam",
  "Asia/Magadan",
  "Asia/Vladivostok",
  "Pacific/Port_Moresby",
  "Australia/Adelaide",
  "Australia/Hobart",
  "Australia/Sydney",
  "Pacific/Guadalcanal",
  "Pacific/Noumea",
  "Pacific/Majuro",
  "Asia/Kamchatka",
  "Pacific/Auckland",
  "Pacific/Fakaofo",
  "Pacific/Fiji",
  "Pacific/Tongatapu",
  "Pacific/Apia"
] as const;

const getTimeZoneOptions = (): { id: string, label: string }[] => {
  return TimeZones.map((timezone) => ({
    id: timezone,
    label: timezone.replace(/_/g," ") 
    // label: `${timezone} (${timezone.slice(timezone.indexOf('(') + 1, timezone.indexOf(')'))})`
  }));
};

const timeZoneOptions = getTimeZoneOptions();
export default timeZoneOptions


// using luxon isInDst => ifTrue -60 minutes from offSet
// Morocco is not a country.
// Antarctica/Troll and Australia/Lord_Howe isn't real either.

